import React from 'react';
import { useEffect } from 'react';
import Navbar2 from '../Navbar2';
import Footer from '../Footer';
import AboutHero from '../AboutHero';
import Team from '../Team';

function AboutPage() {
  useEffect(() => {
    document.title = 'JOBS4US - About';
  }, []);

  return (
    <div>
      <Navbar2 />
      <AboutHero />
      <Team />
      <Footer />
    </div>
  );
}

export default AboutPage;
